import React from "react";
import { AlertTriangle } from "lucide-react";
import { useRates } from "@/context/RatesContext";

export default function RateBanner() {
  const { rates } = useRates();
  if (!rates) return null;
  if (rates.is_today) return null;
  return (
    <div className="bg-hallmark/25 border-b border-hallmark/60 text-rose-gold px-4 py-2.5 text-center text-sm flex items-center justify-center gap-3" data-testid="rates-warning-banner">
      <AlertTriangle className="w-4 h-4" />
      <span>Today's gold rate has not been updated. Prices shown are based on last known rate.</span>
    </div>
  );
}
